import React, { Component } from "react";
import { Link } from "react-router-dom";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";

class Page_header extends Component {
  render() {
    let HeaderTitle = this.props.headertitle;
    let publicUrl = process.env.PUBLIC_URL + "/";
    let Subheader = this.props.subheader
      ? Array.isArray(this.props.subheader)
        ? this.props.subheader
        : [this.props.subheader]
      : [HeaderTitle];

    // Optional paths for subheader navigation
    let SubheaderPaths = this.props.subheaderPaths
      ? Array.isArray(this.props.subheaderPaths)
        ? this.props.subheaderPaths
        : [this.props.subheaderPaths]
      : [];
    let CustomClass = this.props.customclass ? this.props.customclass : "";
    const bgPath = clean(this.props.Img);
    const bg = fileUrl(API_FILE_URL, bgPath);
    let bgClassic = bgPath ? bg : publicUrl + "assets/img/bg/14.jpg";
    const lang = this.props.lang || "tr"; // fallback güvenliği
    const homeLabel = lang === "en" ? "Home" : "Anasayfa";

    return (
      <div
        className={
          "ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image " +
          CustomClass
        }
        data-bs-bg={bgClassic}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner d-flex justify-content-between align-items-center flex-wrap">
                {/* Sol kısım */}
                <div>
                  <h2 className="page-title">{HeaderTitle}</h2>
                  <div className="ltn__breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/">
                          <span className="ltn__secondary-color">
                            <i className="fas fa-home" />
                          </span>{" "}
                          {homeLabel}
                        </Link>
                      </li>

                      {Subheader.map((item, idx) => (
                        <li key={idx}>
                          {SubheaderPaths[idx] ? (
                            <Link to={SubheaderPaths[idx]}>{item}</Link>
                          ) : (
                            item
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Sağ Kısım — Opsiyonel STOCK TICKER */}
                <div
                  className="page-header-right-slot"
                  style={{ minWidth: "320px" }}
                >
                  {this.props.rightSlot}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page_header;
